import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts';
import { Spin } from 'antd';

const PublicRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading || isAuthenticated === null) {
    return (
      <Spin
        tip={
          <div className="text-white/70 text-sm font-normal mt-2">
            Please wait..
          </div>
        }
        size="large"
        fullscreen
      />
    );
  }

  if (isAuthenticated) {
    const redirectPath = localStorage.getItem('redirectPath') || '/';
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
